import { SxProps } from "@mui/material";

import { GroupedTableColumn } from "./GroupedTable";
import { GroupedTableRow } from "./GroupedTableRow";
import { TableBodyItemBundle } from "./styled";

interface Props {
  columns: GroupedTableColumn[];
  items: any[];
  sx?: SxProps;
  selectItem: (item: any, checkBoxSelected: boolean) => void;
  selectedItems: any[];
  onClickRow?: (row: any) => void;
  hideCheckboxes?: boolean;
  disableSelectItems: boolean;
  buildUrl?: (item: any) => string;
}

export const GroupedTableRowBundle = ({
  columns,
  items,
  sx,
  selectItem,
  selectedItems,
  onClickRow,
  hideCheckboxes,
  disableSelectItems,
  buildUrl,
}: Props) => {
  return (
    <TableBodyItemBundle>
      {items.map((item, i) => (
        <GroupedTableRow
          key={item.id + i}
          columns={columns}
          item={item}
          selectItem={selectItem}
          selectedItems={selectedItems}
          onClickRow={onClickRow}
          sx={sx}
          customColor={item.customRowColor}
          hideCheckboxes={hideCheckboxes}
          disableSelectItems={disableSelectItems}
          buildUrl={buildUrl}
        />
      ))}
    </TableBodyItemBundle>
  );
};
